import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { QrCodeSection } from "./components/qr-section/qr-section";
import { Wrapper } from "@cinch-nx/shared-ui";
import styles from "./landing-mobile-app.module.css";
import { WhyAppInformation } from "./components/why-app/why-app";
import { Head } from "@cinch-nx/landing-ui-shared";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
export var LandingMobileApp = function(param) {
    var story = param.story, generatedAt = param.generatedAt, preview = param.preview;
    var body = story.content.body;
    var qrSectionData = body.find(function(qrdata) {
        return qrdata.component === "QR Section";
    });
    var whyAppSectionData = body.find(function(whyAppData) {
        return whyAppData.component === "Why Section";
    });
    var hasQrSection = qrSectionData;
    var hasWhyAppSection = whyAppSectionData;
    var content = useStoryblokState({
        story: story,
        enableBridge: preview
    }).content;
    var ref;
    var ref1 = _sliced_to_array((ref = content === null || content === void 0 ? void 0 : content.SEO) !== null && ref !== void 0 ? ref : [
        {}
    ], 1), SEO = ref1[0];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, _object_spread_props(_object_spread({}, SEO), {
                generatedAt: generatedAt,
                fallbackTitle: "App - cinch",
                fallbackDescription: "We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with free home delivery or from an approved dealer."
            })),
            /*#__PURE__*/ _jsx(Wrapper, {
                isSlim: true,
                className: {
                    container: styles.qrWrapper
                },
                children: hasQrSection && /*#__PURE__*/ _jsx(QrCodeSection, {
                    sectionData: qrSectionData
                })
            }),
            /*#__PURE__*/ _jsx(Wrapper, {
                isSlim: true,
                backgroundColor: "#F2F5FF",
                children: hasWhyAppSection && /*#__PURE__*/ _jsx(WhyAppInformation, {
                    heading: whyAppSectionData.title,
                    listOfItems: whyAppSectionData.icon_list,
                    ariaLabelForList: "why app information section",
                    disclaimer: whyAppSectionData.disclaimer
                })
            })
        ]
    });
};
